import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import "./skeleton.css";
import Addnews from "./Addnews";
import BlogView from "./BlogView";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import Blog from "./Blog";
import Home from "./Home";
import Category from "./Pages/Category";
import Trending from "./Pages/Trending";
import Navbar from "./Navbar";
import Footer from "./Footer";
import About from "./Pages/About";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsConditions from "./Pages/TermsCondition";
import Disclimer from "./Pages/Disclimer";
import PrivacyPolicyGenerator from "./Pages/PrivacyPolicyGen";

function App() {
  const [blog, setBlog] = useState([]);

  useEffect(() => {
    axios
      .get("https://tamizhtechie-test.herokuapp.com/blog/")
      .then((res) => {
        setBlog(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="">
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/blogview" element={<BlogView blog={blog} />} />
          <Route path="/addnews" element={<Addnews />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/category/:name" element={<Category />} />
          <Route path="/trending" element={<Trending blog={blog} />} />

          <Route path="/about" element={<About />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsandcondition" element={<TermsConditions />} />
          <Route path="/disclimer" element={<Disclimer />} />
          <Route
            path="/privacyPolicygenerator"
            element={<PrivacyPolicyGenerator />}
          />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
